<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand to="/">Good Citizen</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item active-class="active" :to="{name:'questionnaire'}" exact>Questionnaire</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'modules'}" exact>Modules</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'about'}" exact>About Us</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'slogans'}" exact>Slogans</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'awards'}" exact>Awards</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'privacyPolicy'}" exact>Privacy Policy</b-nav-item>
          <!-- <b-nav-item active-class="active" :to="{name:'questions'}">Questions</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'choices'}">Choices</b-nav-item>
          <b-nav-item active-class="active" :to="{name:'answers'}">Answers</b-nav-item>-->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <em>{{user}}</em>
            </template>
            <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { app } from "../db";
export default {
  methods: {
    logout() {
      this.$store.dispatch("setUser", null);
      app
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: "login" });
        })
        .catch(function() {
          alert("an Error happened");
        });
    }
  },
  computed: {
    user() {
      return app.auth().currentUser.email;
    }
  }
};
</script>